module.exports = __webpack_public_path__ + "media/mypage/images/fa/5-6f4b8c16a3ed5e8fa4eeed7da5dee117.jpg";